<div class="progress-pie"
     [ngStyle]="{'background': 'linear-gradient(to right, ' + backgroundColor + ' 50%, ' + progressColor + ' 50%, ' + progressColor + ' 100%)'}">
  <div class="progress-pie__progress"
       [ngStyle]="{'transform' : getTransform(), 'background' : getBackground() }"></div>
</div>
